(() => {
  'use strict';
  const ar = document.documentElement.lang.startsWith('ar');
  // Collections show all dresses by default; stock filtering is customer-selected.
  const products = new WeakMap();
  function productFor(root) {
    if (!products.has(root)) {
      try { products.set(root, JSON.parse(root.querySelector('[data-rd-order-product]').textContent)); }
      catch { return null; }
    }
    return products.get(root);
  }
  function update(root, variant) {
    const product = productFor(root);
    if (!product) return;
    if (!variant) {
      const values = [...root.querySelectorAll('.variant-input-wrap')].map(w => w.querySelector('input:checked')?.value);
      variant = product.variants.find(v => v.options.every((value,i) => value === values[i]));
    }
    const link = root.querySelector('[data-rd-special-order]');
    if (!link) return;
    root.dataset.rdSoldout = String(!!variant && !variant.available);
    link.hidden = !variant || variant.available;
    if (!variant) return;
    // Share the direct product route: collection names can be encoded or change later.
    const url = new URL('/products/'+product.handle, location.origin);
    url.searchParams.set('variant',variant.id);
    const message = ar ? `مرحباً، أرغب بطلب خاص للفستان ${product.title}، المقاس / اللون: ${variant.title}. يرجى تأكيد التوفر والمدة.\n${url}` : `Hello, I would like to request ${product.title}, size / color: ${variant.title}. Please confirm availability and lead time.\n${url}`;
    link.href = 'https://wa.me/966548321992?text='+encodeURIComponent(message);
    root.querySelectorAll('[data-rd-installment]').forEach(el => {
      const cents = variant.price / Number(el.dataset.rdInstallment);
      el.textContent = new Intl.NumberFormat(ar?'ar-SA':'en-SA',{style:'currency',currency:'SAR'}).format(cents/100);
    });
  }
  function init(scope=document) {
    scope.querySelectorAll('.product-section').forEach(root => {
      if (!root.dataset.rdRevisionReady) {
        root.dataset.rdRevisionReady = 'true';
        root.addEventListener('variantChange',e => update(root,e.detail.variant));
      }
      update(root);
      const original=root.querySelector('.scr-open-size-chart');
      if(original) {original.tabIndex=-1;original.parentElement.setAttribute('aria-hidden','true');}
    });
  }
  document.addEventListener('click',e => {
    if (e.target.closest('.rd-satc-btn')) {
      const link=document.querySelector('.product-section[data-rd-soldout="true"] [data-rd-special-order]');
      if(link){e.preventDefault();e.stopImmediatePropagation();location.assign(link.href);}
    }
  },true);
  document.addEventListener('change',e => {const root=e.target.closest('.product-section');if(root)setTimeout(()=>update(root),0);});
  document.addEventListener('shopify:section:load',()=>init());
  init();
  document.addEventListener('DOMContentLoaded',()=>init());
})();
